import React from 'react';
import confluencePagesUrl from '../../../../assets/confluence-pages.svg';
import ImageHeader from '../../../../common/components/image-header/index.tsx';

const Header = () => <ImageHeader src={confluencePagesUrl} />;

export default Header;
